import styled, { css } from 'styled-components';

import { Box, Heading, Paragraph } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';
import {
  Bullet,
  ContentColumn,
  Title,
  Wrapper,
} from '@rover/react-lib/src/components/lists/BulletedList/BulletedListItem';

import BulletedList from '../../../components/lists/BulletedList';

export const SPAN_BRAND_2_COLORS_STYLES = css`
  color: ${({ theme }) => theme.colors.green['700']};
`;
export const BACKGROUND_BLUE_100_BRAND_2_COLORS_STYLES = css`
  background-color: ${({ theme }) => theme.colors.blue['100']};
  color: ${({ theme }) => theme.colors.neutral['900']};
`;
export const BACKGROUND_ACCENT_BRAND_2_COLORS_STYLES = css`
  background-color: ${({ theme }) => theme.colors.yellow['100']};
  color: ${({ theme }) => theme.colors.neutral['900']};
`;
export const RED_ICON_BRAND_2_COLORS_STYLES = css`
  fill: ${({ theme }) => theme.colors.red['500']};
`;
export const GREEN_ICON_BRAND_2_COLORS_STYLES = css`
  fill: ${({ theme }) => theme.colors.green['600']};
`;
export const TEXT_BRAND_2_STYLES = css`
  color: ${({ theme }) => theme.colors.neutral['900']};
`;
const LINK_BRAND_2_COLORS_STYLES = css`
  color: ${({ theme }) => theme.colors.blue['600']};
  &:hover {
    color: ${({ theme }) => theme.colors.blue['700']};
  }
`;
export const ParagraphBrand2StyledLink = styled(Paragraph)`
  ${LINK_BRAND_2_COLORS_STYLES}
`;
export const HeadingBrand2StyledLink = styled(Heading)`
  ${LINK_BRAND_2_COLORS_STYLES}
`;
export const StyledBulletedList = styled(BulletedList)<{
  fontSize?: string;
  fontWeight?: number;
  width?: string;
  height?: string;
  pl?: string;
  pr?: string;
}>`
  ${ContentColumn} {
    width: max-content;
  }

  ${Title} {
    font-size: ${({ fontSize, theme }) => fontSize || theme.heading[300].fontSize};
    font-weight: ${({ fontWeight, theme }) =>
      (fontWeight && fontWeight.toString()) || theme.heading[300].fontWeight};
    ${TEXT_BRAND_2_STYLES}
  }

  ${Bullet} {
    width: ${({ theme }) => theme.radii.primary};
    height: ${({ height }) => height || ''};
    margin-right: ${({ theme }) => theme.space['2x']};
  }

  ${Wrapper} {
    flex: 0;
    box-sizing: border-box;
    padding-right: ${({ theme }) => theme.space['6x']};

    &:not(:first-child) {
      margin-top: ${({ theme }) => theme.space['4x']};
    }

    ${MQ.NOT_XS.toString()} {
      width: ${({ width }) => width || '100%'}; // IE11
    }
  }
`;
export const Brand2StyledLink = styled.a`
  ${LINK_BRAND_2_COLORS_STYLES}
`;
export const StyledBox = styled(Box)`
  margin-right: ${({ theme }) => theme.space['12x']};

  ${MQ.XS.toString()} {
    margin-right: ${({ theme }) => theme.space['0x']};
    margin-bottom: ${({ theme }) => theme.space['4x']};
  }
`;
